const FALLBACK_DATE_KEY = "date-unavailable";

function parseConversationDate(value) {
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}

export function conversationTimestamp(call) {
  return call?.occurred_at || call?.created_at || null;
}

export function localConversationDateKey(value) {
  const date = parseConversationDate(value);
  if (!date) return FALLBACK_DATE_KEY;

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export function formatConversationGroupDate(value) {
  const date = parseConversationDate(value);
  if (!date) return "Date unavailable";

  return date.toLocaleDateString("en-US", {
    month: "long",
    day: "numeric",
    year: "numeric",
  });
}

export function formatConversationTime(value) {
  const date = parseConversationDate(value);
  if (!date) return "Time unavailable";

  return date.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function groupCallsByLocalDate(calls = []) {
  const groups = [];

  calls.forEach((call, index) => {
    const timestamp = conversationTimestamp(call);
    const key = localConversationDateKey(timestamp);
    const previous = groups[groups.length - 1];

    if (!previous || previous.key !== key) {
      groups.push({
        key,
        label: formatConversationGroupDate(timestamp),
        timestamp,
        items: [],
      });
    }

    groups[groups.length - 1].items.push({ call, index });
  });

  return groups;
}
